module.exports = __webpack_public_path__ + "static/media/notFound.a7d7ae34.png";